import { useEffect, useRef, useState } from 'react';
import { InputType } from '../../modules/authorization/authorization.type';
import './styles.scss';
import '../dateInput/styles.scss';
import { observer } from 'mobx-react-lite';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import cn from 'classnames';

export const AuthSelect: React.FC<{
  input: InputType;
  onChange: Function;
  initValue?: string;
}> = observer(({ input, onChange, initValue = '' }) => {
  const { id, label, placeholder, name, options, validation } = input;
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    initValue || placeholder,
  );
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [selected, setSelected] = useState<boolean>(true);
  const didMount = useRef(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => setIsOpened(false));
  const chackChange = (text: string, value: string) => {
    setSelectedValue(text);
    onChange(name, value, true);
    setIsOpened(false);
    setSelected(false);
  };

  useEffect(() => {
    if (initValue) {
      setSelected(false);
    }
  }, [initValue]);

  useEffect(() => {
    if (!didMount.current) didMount.current = true;
    else if (!isOpened && selectedValue === placeholder) {
      onChange(name, '', false);
    }
  }, [selectedValue, isOpened]);

  const toggleSelect = () => {
    setIsOpened(!isOpened);
  };

  return (
    <div className="authInputWrp" ref={ref}>
      <label className="authInputText" htmlFor={String(id)}>
        {label}
      </label>
      <div
        tabIndex={0}
        className={cn('authDropDowCase', 'lg', {
          open: isOpened,
          error:
            !validation.status && selectedValue !== (initValue || placeholder),
        })}
        onClick={toggleSelect}
      >
        <p className={`authDropDownText ${selected && 'selected'}`}>
          {selectedValue}
        </p>
        <div className="authDropDownIconCase">
          <i className="icon-chevron-bottom" />
        </div>
        <div className="authDropDownInner">
          <div className="authDropDownContentWrp">
            <div className="authDropDownContentInner">
              {options?.map(
                (option: { value: string; id: number; text: string }) => (
                  <div
                    key={option.id}
                    className="authDropDownRow"
                    onClick={() => chackChange(option.text, option.value)}
                  >
                    <p className="authDropDownText">{option.text}</p>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
